// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_hu-0";
export var actionModalContentContainer = "_hu-1";
export var createTagButton = "_hu-2";
export var footerContainer = "_hu-7";
export var fullWidthDivider = "_hu-3";
export var hasCreateTagButton = "_hu-4";
export var noCreateTagButton = "_hu-5";
export var tagsContainer = "_hu-6";
export var tagsModalContentContainer = "_hu-8";